export default __webpack_public_path__ + "static/media/ic-sort-up-select.7bdb1203.svg";